"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class ModifierApi {
    constructor(api) {
        this.api = api;
    }
    /**
     * 取得餐廳的自訂折扣
     */
    getModifier() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/modifier';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * 新增餐廳的自訂折扣
     */
    createModifier(modifier) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/modifier';
            const response = yield this.api.axiosGo.post(endpoint, modifier);
            return response.data;
        });
    }
    /**
     * 修改餐廳的自訂折扣
     */
    updateModifier(modifierId, modifier) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/modifier/${modifierId}`;
            const response = yield this.api.axiosGo.put(endpoint, modifier);
            return response.data;
        });
    }
    /**
     * 刪除餐廳的自訂折扣
     */
    deleteModifier(modifierId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/modifier/${modifierId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
}
exports.default = ModifierApi;
//# sourceMappingURL=Modifier.js.map